module.exports = __webpack_public_path__ + "media/images/pages/home_featured/contributor-overview-header-e7aaa69d9077186523f936e63554d5bb.png";